import * as Sentry from '@sentry/react';

import { getUserId } from './getUserId';
import { ErrorsTag, ResponseData } from './Api.model';
import { apiEvents, events } from './Api';

export const badRequestCode = <D>(response: Response) => {
  (response.json() as Promise<ResponseData<D>>).then((data) => {
    getUserId().then((userId) => {
      Sentry.withScope((scope) => {
        scope.setUser({ id: userId!.toString() });
        Sentry.captureException(data?.message, {
          tags: {
            error_message: ErrorsTag.BadRequest,
            https_status: response.status
          },
          extra: {
            responseData: data
          }
        });
      });
    });
    events.emit(apiEvents.ERROR);
  });
};

export const notFoundCode = <D>(response: Response) => {
  (response.json() as Promise<ResponseData<D>>).then((data) => {
    getUserId().then((userId) => {
      Sentry.withScope((scope) => {
        scope.setUser({ id: userId!.toString() });
        Sentry.captureException(data?.message, {
          tags: {
            error_message: ErrorsTag.NotFound,
            https_status: response.status
          },
          extra: {
            responseData: data
          }
        });
      });
    });
    events.emit(apiEvents.NOT_FOUND);
  });
};

export const generalError = <D>(response: Response) => {
  (response.json() as Promise<ResponseData<D>>).then((data) => {
    getUserId().then((userId) => {
      Sentry.withScope((scope) => {
        scope.setUser({ id: userId!.toString() });
        Sentry.captureException(data?.message, {
          tags: {
            error_message: ErrorsTag.Modal,
            https_status: response.status
          },
          extra: {
            responseData: data
          }
        });
      });
    });
    events.emit(apiEvents.GENERAL_ERROR);
  });
};

export const generalErrorSuccessFalse = <D>(
  data: ResponseData<D>,
  status: number
) => {
  getUserId().then((userId) => {
    Sentry.withScope((scope) => {
      scope.setUser({ id: userId!.toString() });
      Sentry.captureException(data.message, {
        tags: {
          error_message: ErrorsTag.Modal,
          https_status: status,
          success: data.success
        },
        extra: {
          responseData: data
        }
      });
    });
  });
  events.emit(apiEvents.GENERAL_ERROR);
};

export const failedToFetch = (error: any) => {
  getUserId().then((userId) => {
    Sentry.withScope((scope) => {
      scope.setUser({ id: userId!.toString() });
      Sentry.captureException(error, {
        tags: {
          error_message: ErrorsTag.Modal,
          https_status: error.status
        }
      });
    });
  });
  events.emit(apiEvents.GENERAL_ERROR);
};
